import browse from './browse.vue';
import form from './form.vue';
import read from './read.vue';
import tasks from './tasks';

export default { browse, create: form, read, edit: form, tasks };
